var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "l-crew-settings-wrapper" }, [
    _c("div", { staticClass: "grid-container full" }, [
      _c("div", { staticClass: "grid-margin-x" }, [
        _c("div", { staticClass: "cell u-no-margin" }, [
          _c(
            "div",
            { staticClass: "action action--page u-extra-small-margin--bottom" },
            [
              _c(
                "router-link",
                {
                  staticClass: "button button--prev",
                  attrs: {
                    to: { name: "weeks", params: { date: _vm.startdate } },
                    title: _vm.$t("prev_page"),
                  },
                },
                [_vm._v(_vm._s(_vm.$t("prev_page")))]
              ),
              _vm._v(" "),
              _c("h1", { staticClass: "u-no-margin" }, [
                _vm._v(_vm._s(_vm.getPageTitle) + " "),
                _c("span", { staticClass: "u-color--primary" }, [
                  _vm._v("KW " + _vm._s(_vm.week)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLoading,
                      expression: "isLoading",
                    },
                  ],
                },
                [_c("v-page-loading")],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-container full" }, [
      _c("div", { staticClass: "grid-x grid-margin-x" }, [
        _c(
          "div",
          {
            staticClass:
              "cell medium-9 medium-offset-1 large-11 large-offset-0 u-no-margin",
          },
          [
            _c("v-action-buttons", {
              attrs: { items: _vm.getActionButtons },
              on: { actionClicked: _vm.onClickAction },
            }),
            _vm._v(" "),
            _vm.shouldShowEmployeesModal
              ? _c("KolonneSettingsEmployeesModal", {
                  attrs: {
                    isVisible: _vm.shouldShowEmployeesModal,
                    week: _vm.week,
                    startdate: _vm.startdate,
                    "selected-kolonne-id": _vm.selectedKolonneId,
                    "selected-kolonne-number": _vm.selectedKolonneNumber,
                    "selected-employee-ids": _vm.selectedEmployeeIds,
                    "available-employees": _vm.allEmployees,
                    "kolonne-content": _vm.kolonne_content,
                  },
                  on: {
                    saved: _vm.onEmployeesSavedFromModal,
                    refreshedEmployees: _vm.onEmployeesRefreshed,
                  },
                  model: {
                    value: _vm.shouldShowEmployeesModal,
                    callback: function ($$v) {
                      _vm.shouldShowEmployeesModal = $$v
                    },
                    expression: "shouldShowEmployeesModal",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.shouldShowVehiclesModal
              ? _c("KolonneSettingsVehiclesModal", {
                  attrs: {
                    isVisible: _vm.shouldShowVehiclesModal,
                    week: _vm.week,
                    startdate: _vm.startdate,
                    "selected-kolonne-id": _vm.selectedKolonneId,
                    "selected-kolonne-number": _vm.selectedKolonneNumber,
                    "selected-vehicle-ids": _vm.selectedVehicleIds,
                    "available-vehicles": _vm.allVehicles,
                    "kolonne-content": _vm.kolonne_content,
                  },
                  on: {
                    saved: _vm.onVehiclesSavedFromModal,
                    refreshedVehicles: _vm.onVehiclesRefreshed,
                  },
                  model: {
                    value: _vm.shouldShowVehiclesModal,
                    callback: function ($$v) {
                      _vm.shouldShowVehiclesModal = $$v
                    },
                    expression: "shouldShowVehiclesModal",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("v-vehicles-modal", {
              attrs: {
                isVisible: _vm.vehiclesModal.isVisible,
                current_kolonne_id: _vm.vehiclesModal.current_kolonne_id,
                current_vehicles: _vm.vehiclesModal.current_vehicles,
                current_kolonne_number:
                  _vm.vehiclesModal.current_kolonne_number,
              },
              on: { vehicles: _vm.refreshVehiclesFromModal },
              model: {
                value: _vm.vehiclesModal.isVisible,
                callback: function ($$v) {
                  _vm.$set(_vm.vehiclesModal, "isVisible", $$v)
                },
                expression: "vehiclesModal.isVisible",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dialog",
                class: { active: _vm.showDuplicateDialog },
              },
              [
                _c(
                  "div",
                  { staticClass: "dialog--content dialog--medium-width" },
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.$t("kolonne.settings.duplicate.title"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "u-extra-medium-margin--bottom" }, [
                      _vm._v("\n              Personen:\n              "),
                      _vm.duplicateItem.crew
                        ? _c("i", [_vm._v(_vm._s(_vm.duplicateItem.crew))])
                        : _vm.duplicateItem.employees &&
                          _vm.duplicateItem.employees.length > 0
                        ? _c("i", [
                            _vm._v(
                              _vm._s(
                                _vm.duplicateItem.employees.map(
                                  (employee) =>
                                    `${employee.firstName} ${employee.lastName}`
                                )
                              )
                            ),
                          ])
                        : _c("i", [_vm._v("keine gewählt")]),
                      _vm._v(
                        ",\n\n              " +
                          _vm._s(_vm.$t("form.project.site_contact_info")) +
                          ":\n              "
                      ),
                      _c("i", [_vm._v(_vm._s(_vm.duplicateItem.contact))]),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "u-extra-medium-margin--bottom" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("kolonne.settings.duplicate.desc")) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid-x grid-margin-x" }, [
                      _c("div", { staticClass: "cell small-auto medium-6" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("kolonne.number"))),
                            ]),
                            _vm._v(" "),
                            _c("v-select-kolonne", {
                              attrs: {
                                id: "form-field-kolonne",
                                name: "kolonne",
                                placeholder: _vm.$t("select_all"),
                              },
                              model: {
                                value: _vm.duplicateItem.target_kolonne,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.duplicateItem,
                                    "target_kolonne",
                                    $$v
                                  )
                                },
                                expression: "duplicateItem.target_kolonne",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cell small-auto medium-6" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Datum")]),
                            _vm._v(" "),
                            _c("v-datepicker", {
                              staticClass:
                                "form-control form-control--small form-control--date",
                              attrs: {
                                id: "pickdate",
                                placeholder: "Datum",
                                format: _vm.$helpers.dateFormat,
                                clearButton: true,
                                "monday-first": true,
                                language: _vm.de,
                                "disabled-dates": {
                                  days: [6, 0],
                                  to: new Date(
                                    _vm.duplicateItem.next_week_startdate
                                  ),
                                },
                              },
                              model: {
                                value: _vm.duplicateItem.target_date,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.duplicateItem,
                                    "target_date",
                                    $$v
                                  )
                                },
                                expression: "duplicateItem.target_date",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          attrs: { disabled: _vm.isLoading },
                          on: {
                            click: function ($event) {
                              return _vm.duplicateKolonneSettings()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("save")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button gray",
                          on: {
                            click: function ($event) {
                              return _vm.onCloseDuplicateDialog()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close-button",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onCloseDuplicateDialog()
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "box u-extra-large-padding--bottom u-extra-medium-padding--top",
              },
              [
                _c("div", { staticClass: "grid-x grid-margin-x" }, [
                  _c("div", { staticClass: "cell small-1" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell auto" }, [
                    _c("div", { staticClass: "grid-x grid-margin-x" }, [
                      _c("div", { staticClass: "cell medium-4" }, [
                        _c(
                          "p",
                          { staticClass: "u-extra-small-margin--bottom" },
                          [_c("strong", [_vm._v(_vm._s(_vm.$t("personnel")))])]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cell medium-4" }, [
                        _c(
                          "p",
                          { staticClass: "u-extra-small-margin--bottom" },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("kolonne.settings.vehicles"))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cell medium-3" }, [
                        _c(
                          "p",
                          { staticClass: "u-extra-small-margin--bottom" },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("kolonne.settings.comment"))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cell small-1" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "u-extra-small-margin--bottom text-center",
                          },
                          [_c("strong", [_vm._v(_vm._s(_vm.$t("duplicate")))])]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(this.kolonne_content, function (kolonneSettings, index) {
                  return _c(
                    "section",
                    { key: index, staticClass: "u-extra-small-margin--bottom" },
                    [
                      _c(
                        "div",
                        { staticClass: "grid-x grid-margin-x align-middle" },
                        [
                          _c("div", { staticClass: "cell small-1" }, [
                            _c(
                              "label",
                              { staticClass: "u-no-margin--bottom" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: kolonneSettings.active,
                                      expression: "kolonneSettings.active",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    name: "selected_crews[]",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      kolonneSettings.active
                                    )
                                      ? _vm._i(kolonneSettings.active, null) >
                                        -1
                                      : kolonneSettings.active,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = kolonneSettings.active,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              kolonneSettings,
                                              "active",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              kolonneSettings,
                                              "active",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(kolonneSettings, "active", $$c)
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("i"),
                                _vm._v(" "),
                                _c("span", { staticClass: "h5" }, [
                                  _vm._v(_vm._s(kolonneSettings.kolonne)),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cell auto" }, [
                            _c("div", { staticClass: "grid-x grid-margin-x" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cell medium-4 u-background u-background--gray",
                                },
                                [
                                  !kolonneSettings.active && !kolonneSettings.id
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "u-text-center u-extra-small-margin--bottom u-extra-small-margin--top",
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "kolonne.settings.notactivated"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      )
                                    : kolonneSettings.active &&
                                      !kolonneSettings.id
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "u-text-center u-extra-small-margin--bottom u-extra-small-margin--top",
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "kolonne.settings.notsaved"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      )
                                    : kolonneSettings.crew
                                    ? _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: kolonneSettings.crew,
                                            expression: "kolonneSettings.crew",
                                          },
                                        ],
                                        staticClass: "form__textarea--small",
                                        domProps: {
                                          value: kolonneSettings.crew,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              kolonneSettings,
                                              "crew",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-crew-settings-box u-no-margin",
                                        },
                                        [
                                          Array.isArray(
                                            kolonneSettings.employees_ids
                                          ) &&
                                          kolonneSettings.employees_ids.length >
                                            0
                                            ? [
                                                _c(
                                                  "ul",
                                                  _vm._l(
                                                    kolonneSettings.employees,
                                                    function (employee) {
                                                      return _c(
                                                        "li",
                                                        { key: employee.id },
                                                        [
                                                          _c(
                                                            "KolonneSettingsAssignedEmployee",
                                                            {
                                                              attrs: {
                                                                employee:
                                                                  employee,
                                                                startdate:
                                                                  _vm.startdate,
                                                                "kolonne-content":
                                                                  _vm.kolonne_content,
                                                                "selected-kolonne-id":
                                                                  kolonneSettings.id,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "o-crew-button o-crew-button--edit",
                                                    attrs: {
                                                      title: _vm.$t("update"),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.openEmployeesModal(
                                                          kolonneSettings.id,
                                                          kolonneSettings.kolonne
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "u-icon--edit",
                                                        attrs: {
                                                          role: "presentation",
                                                        },
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xlink:href":
                                                              "/dist/sprite.svg#icon-edit",
                                                            href: "/dist/sprite.svg#icon-edit",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "o-crew-button o-crew-button--add--hover",
                                                    attrs: {
                                                      title:
                                                        _vm.$t("create_new"),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.openEmployeesModal(
                                                          kolonneSettings.id,
                                                          kolonneSettings.kolonne
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "u-icon--add",
                                                        attrs: {
                                                          role: "presentation",
                                                        },
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xlink:href":
                                                              "/dist/sprite.svg#icon-add",
                                                            href: "/dist/sprite.svg#icon-add",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cell medium-4 u-background u-background--gray",
                                },
                                [
                                  !kolonneSettings.active && !kolonneSettings.id
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "u-text-center u-extra-small-margin--bottom u-extra-small-margin--top",
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "kolonne.settings.notactivated"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      )
                                    : kolonneSettings.active &&
                                      !kolonneSettings.id
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "u-text-center u-extra-small-margin--bottom u-extra-small-margin--top",
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "kolonne.settings.notsaved"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-crew-settings-box u-no-margin",
                                        },
                                        [
                                          Array.isArray(
                                            kolonneSettings.vehicles
                                          ) &&
                                          kolonneSettings.vehicles.length >= 1
                                            ? [
                                                _c(
                                                  "ul",
                                                  {
                                                    staticClass:
                                                      "c-vehicle__list",
                                                  },
                                                  _vm._l(
                                                    kolonneSettings.vehicles,
                                                    function (
                                                      kolonneSettings,
                                                      index
                                                    ) {
                                                      return _c(
                                                        "li",
                                                        { key: index },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                kolonneSettings.type
                                                              ) + ":"
                                                            ),
                                                          ]),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                kolonneSettings.number
                                                              ) +
                                                              "\n                            "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "o-crew-button o-crew-button--edit",
                                                    attrs: {
                                                      title: _vm.$t("update"),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.openDeprecatedVehiclesModal(
                                                          kolonneSettings.id,
                                                          kolonneSettings.vehicles,
                                                          kolonneSettings.kolonne
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "u-icon--edit",
                                                        attrs: {
                                                          role: "presentation",
                                                        },
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xlink:href":
                                                              "/dist/sprite.svg#icon-edit",
                                                            href: "/dist/sprite.svg#icon-edit",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : Array.isArray(
                                                kolonneSettings.fleet
                                              ) &&
                                              kolonneSettings.fleet.length > 0
                                            ? [
                                                _c(
                                                  "ul",
                                                  _vm._l(
                                                    kolonneSettings.fleet,
                                                    function (vehicle) {
                                                      return _c(
                                                        "li",
                                                        { key: vehicle.id },
                                                        [
                                                          _c(
                                                            "KolonneSettingsAssignedVehicle",
                                                            {
                                                              attrs: {
                                                                vehicle:
                                                                  vehicle,
                                                                startdate:
                                                                  _vm.startdate,
                                                                "kolonne-content":
                                                                  _vm.kolonne_content,
                                                                "selected-kolonne-id":
                                                                  kolonneSettings.id,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "o-crew-button o-crew-button--edit",
                                                    attrs: {
                                                      title: _vm.$t("update"),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.openVehiclesModal(
                                                          kolonneSettings.id,
                                                          kolonneSettings.kolonne
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "u-icon--edit",
                                                        attrs: {
                                                          role: "presentation",
                                                        },
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xlink:href":
                                                              "/dist/sprite.svg#icon-edit",
                                                            href: "/dist/sprite.svg#icon-edit",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "o-crew-button o-crew-button--add--hover",
                                                    attrs: {
                                                      title:
                                                        _vm.$t("create_new"),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.openVehiclesModal(
                                                          kolonneSettings.id,
                                                          kolonneSettings.kolonne
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "u-icon--add",
                                                        attrs: {
                                                          role: "presentation",
                                                        },
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xlink:href":
                                                              "/dist/sprite.svg#icon-add",
                                                            href: "/dist/sprite.svg#icon-add",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cell medium-3" },
                                [
                                  !kolonneSettings.active && !kolonneSettings.id
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "u-text-center u-extra-small-margin--top u-extra-small-margin--bottom",
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "kolonne.settings.notactivated"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      )
                                    : _c("AutosizeTextarea", {
                                        staticClass: "form__textarea--small",
                                        attrs: { rows: "1" },
                                        model: {
                                          value: kolonneSettings.comment,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              kolonneSettings,
                                              "comment",
                                              $$v
                                            )
                                          },
                                          expression: "kolonneSettings.comment",
                                        },
                                      }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cell small-1 flex-container flex-dir-column align-middle",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button button--action button--action--duplicate button--small button--medium",
                                      attrs: { title: _vm.$t("duplicate") },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.onOpenDuplicateDialog(
                                            kolonneSettings
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(_vm.$t("duplicate")) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "grid-x grid-margin-x align-middle" },
                  [
                    _c("div", { staticClass: "cell small-1" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell auto" }, [
                      _c(
                        "div",
                        { staticClass: "grid-x grid-margin-x align-middle" },
                        [
                          _c(
                            "div",
                            { staticClass: "cell auto" },
                            [
                              _c("hr"),
                              _vm._v(" "),
                              _c("KolonneSettingsCrudEmployeesRankingLegend"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "cell auto" },
                            [
                              _c("hr"),
                              _vm._v(" "),
                              _c("KolonneSettingsCrudVehiclesRankingLegend"),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }